export default __webpack_public_path__ + "static/media/Conscript's Chestplate of the Battlements.9c03e5bb.jpg";